import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy Integrations index — retired in favor of Connections.
 * Per-connection detail routes (integrations.$connectionId, etc.) are kept
 * intact for deep links until they are migrated into the Connections workspace.
 */
export const Route = createFileRoute("/_authenticated/app/admin/integrations/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/admin/connections" });
  },
});
